
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Products from "../pages/products/page";
import Trust from "../pages/trust/page";
import Honors from '../pages/honors/page';
import Consultation from '../pages/consultation/page';
import Join from '../pages/join/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/products',
    element: <Products />
  },
  {
    path: '/trust',
    element: <Trust />
  },
  {
    path: '/honors',
    element: <Honors />
  },
  {
    path: '/consultation',
    element: <Consultation />
  },
  {
    path: '/join',
    element: <Join />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;